exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal-report{width:850px!important;height:450px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/core/components/ui-crud/ui-crud-view/ui-crud-view.scss
// module id = 839
// module chunks = 0